import frontFooter from "./frontFooter"
export default frontFooter;
